// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main_3QC2M","waitResponse":"index_waitResponse_H-Kk2","time":"index_time_2qvWW","right":"index_right_1FYU5"};